export interface ChatMessage {
  id: string;
  role: 'user' | 'assistant';
  content: string;
  timestamp: Date;
  isError?: boolean;
}

export const CHAT_URL = `${import.meta.env.VITE_SUPABASE_URL}/functions/v1/financial-chatbot`;
